import {
  CarBodyType,
  DriveType,
  EngineType,
  TransmissionType,
  VehicleCondition,
} from "@oriental-ramirez/shared";

export const CONDITION_OPTIONS = Object.values(VehicleCondition).map((v) => ({ label: v, value: v }));
export const ENGINE_TYPE_OPTIONS = Object.values(EngineType).map((v) => ({ label: v, value: v }));
export const TRANSMISSION_OPTIONS = Object.values(TransmissionType).map((v) => ({ label: v, value: v }));
export const CAR_BODY_OPTIONS = Object.values(CarBodyType).map((v) => ({ label: v, value: v }));
export const DRIVE_TYPE_OPTIONS = Object.values(DriveType).map((v) => ({ label: v, value: v }));

export const MOTORCYCLE_TYPE_OPTIONS = [
  { label: "Deportiva", value: "Deportiva" },
  { label: "Cruiser", value: "Cruiser" },
  { label: "Touring", value: "Touring" },
  { label: "Naked", value: "Naked" },
  { label: "Adventure", value: "Adventure" },
  { label: "Dual Sport", value: "Dual Sport" },
  { label: "Scooter", value: "Scooter" },
  { label: "Enduro", value: "Enduro" },
  { label: "Cafe Racer", value: "Cafe Racer" },
];

export const STARTER_TYPE_OPTIONS = [
  { label: "Eléctrico", value: "Eléctrico" },
  { label: "Patada", value: "Patada" },
  { label: "Eléctrico y Patada", value: "Eléctrico y Patada" },
];

export const COOLING_OPTIONS = ["Aire", "Líquido", "Aire/Aceite"];
